import React from 'react';
import { Box } from "@mui/material";
import { APP_BANNER_URL } from '../../../../utils/constants';
import { DashboardData } from '../../../../api/interfaces/Dashboard';

interface BannerPartialProps {
    currentDashboard: DashboardData | undefined;
}
const BannerPartial: React.FC<BannerPartialProps> = ({ currentDashboard }) => {
    return (
        <Box
            component="section"
            sx={{
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
                height: { xs: 150, sm: 200, md: 210 },
            }}
        >
            {/* Banner image */}
            <Box
                component="img"
                src={(currentDashboard?.program && currentDashboard.program.banner) ? currentDashboard.program.banner : APP_BANNER_URL}
                alt="CPA Banner"
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
            />
        </Box>
    );
};

export default BannerPartial;
